// extracted by mini-css-extract-plugin
module.exports = {"qualities":"Qualities_qualities__h6p_u","qualityDescription":"Qualities_qualityDescription__mLhpj"};